import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/5c0ad1e95b49fc3621673298b03cd410/cee89e20f7d26bfc174a546f85a70f24.png"
              alt="Drive With US"
              className="h-16 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('frota')}
              className="text-[#1e3a8a] hover:text-[#c53030] font-medium transition-colors cursor-pointer"
            >
              Frota
            </button>
            <button
              onClick={() => scrollToSection('orcamento')}
              className="text-[#1e3a8a] hover:text-[#c53030] font-medium transition-colors cursor-pointer"
            >
              Orçamento
            </button>
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-[#1e3a8a] hover:text-[#c53030] font-medium transition-colors cursor-pointer"
            >
              Sobre Nós
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-[#1e3a8a] hover:text-[#c53030] font-medium transition-colors cursor-pointer"
            >
              Contato
            </button>
          </div>

          <button
            onClick={() => scrollToSection('orcamento')}
            className="hidden md:flex items-center gap-2 bg-[#c53030] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#a02525] transition-colors whitespace-nowrap cursor-pointer"
          >
            Reserve Agora
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
